import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { FetchAreaWrapper, FetchListingWrapper } from 'app/shared/LoadablePages';
import constants from 'app/shared/constants/ConstantsBundle';
import { ImmersiveOverlay } from 'app/shared/halo/components/features/listings/ImmersiveOverlay';
import { useImmersiveOverlay } from 'app/shared/halo/stores/immersiveOverlayStore';
import { StyledSplitMapSideBar } from './styles';

export const FetchListingWrapperUrls = [
  '/:addressWithMalone/building',
  '/:addressWithMalone/pad',
  '/:addressWithMalone/pad-for-sublet',
  '/:addressWithMalone/pad-for-sale',
  '/:addressWithMalone/pad-for-auction',
  '/:addressWithMalone/pad-corporate-housing',
  '/:addressWithMalone/pad-foreclosure',
  '/:addressWithMalone/:urlMaloneUnit/pad',
  '/:addressWithMalone/:urlMaloneUnit/pad-for-sublet',
  '/:addressWithMalone/:urlMaloneUnit/pad-for-sale',
  '/:addressWithMalone/:urlMaloneUnit/pad-for-auction',
  '/:addressWithMalone/:urlMaloneUnit/pad-corporate-housing',
  '/:addressWithMalone/:urlMaloneUnit/pad-foreclosure',
];

const nearMeUrlArray = Object.keys(constants.NEAR_ME_ROUTES);
// Keep nearMeUrlArray immutable; make a copy instead
const FetchAreaWrapperUrls = nearMeUrlArray.slice();
FetchAreaWrapperUrls.unshift(`/:areaResourceId/:searchSlug`);

const SplitMapSidebar = (props: Record<string, unknown>) => {
  const haloHdp = useSelector((state: Record<string, unknown>) =>
    Boolean((state.app as Record<string, unknown>)?.haloHdp),
  );
  const { isOpen: isImmersiveOpen } = useImmersiveOverlay();
  const showImmersive = haloHdp && isImmersiveOpen;

  return (
    <>
      <StyledSplitMapSideBar
        id="SplitMapTemplate-right-sidebar"
        style={showImmersive ? { overflow: 'hidden' } : undefined}
      >
        {!showImmersive && (
          <Switch>
            <Route path={FetchListingWrapperUrls}>
              <FetchListingWrapper {...props} />
            </Route>
            <Route path={FetchAreaWrapperUrls}>
              <FetchAreaWrapper {...props} />
            </Route>
          </Switch>
        )}
        {showImmersive && <ImmersiveOverlay />}
      </StyledSplitMapSideBar>
    </>
  );
};

export default SplitMapSidebar;
